import * as process from "process"; //to solve Uncaught reference error, process is not defined
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

//to solve Uncaught reference error, process is not defined
window.global = window;
window.process = process;
window.Buffer = [];
//end of code

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("✅ Service Worker registered with scope:", registration.scope);
    })
    .catch((err) => {
      console.error("❌ Service Worker registration failed:", err);
    });
}

reportWebVitals();
